import { Card, Col, Label, Row } from 'reactstrap';

const RoleTabs = () => {
  return (
    <>
      <Card>
        <Row>
          <Col>
            <Label>Admin</Label>
          </Col>
          <Col>
            <Label>Managers</Label>
          </Col>
          <Col>
            <Label>Operators</Label>
          </Col>
        </Row>
      </Card>
    </>
  );
};

export default RoleTabs;
